
export const assessment = {
  title: 'Behavioral Assessment',
  instructions: 'Select as many words as you feel describe you best',
  selectWords: 'Select as many words as you feel describe you best:',
  progress: 'Progress',
  complete: 'Complete Assessment',
  selectedCount: 'Selected',
  totalWords: 'Total Words',
  startAssessment: 'Start Assessment',
  behavior: {
    title: 'Behavioral Assessment',
    instruction: 'Select as many words as you feel describe you best',
    subtitle: 'Discover your behavioral style by selecting words that best describe you'
  },
  instructionCards: {
    selectWords: {
      title: 'Select Words',
      description: 'Choose as many words as you feel describe you best'
    },
    beAuthentic: {
      title: 'Be Authentic',
      description: 'Select words that truly represent you'
    },
    takeYourTime: {
      title: 'Take Your Time',
      description: 'No rush - reflect on each choice'
    }
  },
  wordCounter: {
    selected: 'words selected'
  },
  wordCategories: {
    dominance: 'Drive',
    influence: 'Connection', 
    steadiness: 'Task',
    conscientiousness: 'Order',
    objectivity: 'Style'
  },
  completion: {
    title: 'Assessment Complete!',
    subtitle: 'Thank you for completing the assessment.',
    viewResults: 'View Results',
    downloadPDF: 'Download PDF Report'
  },
  stages: {
    self: {
      title: 'Self Behavior Assessment',
      subtitle: 'How do you naturally behave?',
      description: 'Select words that describe your natural behavioral tendencies and preferences',
      tip: 'Think about how you naturally act when you\'re comfortable and being yourself'
    },
    work: {
      title: 'Work Behavior Assessment',
      subtitle: 'How do others expect you to behave at work?',
      description: 'Select words that describe how colleagues, managers, and team members expect you to act professionally',
      tip: 'Think about workplace expectations, not your natural behavioral preferences'
    }
  },
  stageIndicator: {
    stage: 'Stage',
    of: 'of'
  },
  controls: {
    continueToWork: 'Continue to Work Behavior',
    viewResults: 'View Combined Results',
    continue: 'Continue',
    viewResultsButton: 'View Results',
    selectMoreWords: 'Select {{count}} more word{{plural}} to continue',
    selectAtLeast: 'Select at least {{min}} words ({{remaining}} more)',
    selected: 'selected',
    step: 'Step',
    of: 'of',
    processing: 'Processing...',
    minimumWords: 'You need a minimum of 8 words'
  },
  m3Instructions: {
    subtitle: 'Select words that describe you authentically, then continue.',
    tip1: 'Choose words that reflect your natural behavior',
    tip2: 'There are no right or wrong answers',
    tip3: 'Takes about 10 minutes',
    backToHome: 'Back to home',
    aiWarningTitle: 'Academic Integrity Notice',
    aiWarningText: 'Use of AI tools, external assistance, or any unauthorized resources is strictly prohibited. Our system actively monitors for irregular patterns. Candidates found using AI or external help will be immediately disqualified.'
  },
  workBehavior: {
    title: 'Work Behavior Assessment',
    description: 'Select words that describe how you behave at work. This helps identify your professional behavioral style.',
    selectWords: 'Select Words That Describe Your Work Behavior',
    selectWordsSubtitle: 'Choose words that best describe your work behavior'
  }
};
